import { Spinner } from '@/components/ui/spinner';

interface LoadingStateProps {
  /** Сообщение загрузки */
  message?: string;
  /** CSS классы контейнера */
  className?: string;
}

/**
 * Универсальный компонент состояния загрузки
 * 
 * @example
 * ```tsx
 * if (isLoading) {
 *   return <LoadingState message="Загрузка..." />;
 * }
 * ```
 */
export function LoadingState({
  message,
  className = 'flex items-center justify-center py-8'
}: LoadingStateProps): JSX.Element {
  return (
    <div className={className}>
      <div className="flex flex-col items-center gap-2">
        <Spinner />
        {message && (
          <p className="text-sm text-muted-foreground">{message}</p>
        )}
      </div>
    </div>
  );
}